/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseDocumentsListItemViewModel } from "../types/CourseDocumentsListItemViewModel.ts";

export const courseDocumentsListItemViewModelSchema = z.object({
  id: z.optional(
    z.number().int().describe("ID do vínculo entre o curso e o documento."),
  ),
  courseId: z.optional(z.number().int().describe("ID do curso.")),
  documentId: z.optional(
    z.number().int().describe("ID do documento-modelo vinculado."),
  ),
  documentName: z
    .string()
    .describe(
      "Nome do documento no vínculo; quando não informado, o nome do documento-modelo.",
    )
    .nullish(),
  isFile: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a declaração é entregue como arquivo PDF em vez de conteúdo HTML.",
      ),
  ),
  useDigitalValidation: z.optional(
    z.boolean().describe("Indica se a declaração usa validação digital."),
  ),
  usePortuguese: z.optional(
    z
      .boolean()
      .describe("Indica se a declaração está habilitada em português."),
  ),
  useEnglish: z.optional(
    z.boolean().describe("Indica se a declaração está habilitada em inglês."),
  ),
  useSpanish: z.optional(
    z.boolean().describe("Indica se a declaração está habilitada em espanhol."),
  ),
  documentActive: z.optional(
    z.boolean().describe("Indica se o documento-modelo está ativo."),
  ),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do vínculo. Opcional.")
    .nullish(),
  userLastChange: z
    .string()
    .describe("Usuário responsável pela última alteração. Opcional.")
    .nullish(),
}) as unknown as ToZod<CourseDocumentsListItemViewModel>;
